// @flow

import type {Language, PortfolioEventMetrics} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appActions, appSelectors, portfoliosSelectors} from '@/store'
import moment from 'moment'

import CountBox from './count-box'

import './index.css'

type Props = {
  eventsSummary: PortfolioEventMetrics,
  l: Language,
}

export class RawBox extends Component<Props> {
  render () {
    const {
      eventsSummary,
      l,
    } = this.props
    const currentTime = moment()
    return (
      <div className="row notification-counts">
        <div className="col-xs-3">
          <CountBox
            id='events_last_24_hours'
            label={'Events last 24 hours'}
            count={eventsSummary.day || 0}
            l={l}
            startDate={moment(currentTime).subtract(24, 'hours')}
            endDate={currentTime}
          />
        </div>
        <div className="col-xs-3">
          <CountBox
            id='events_last_7_days'
            label={'Events last 7 days'}
            count={eventsSummary.week || 0}
            l={l}
            startDate={moment(currentTime).subtract(7, 'days')}
            endDate={currentTime}
          />
        </div>
        <div className="col-xs-3">
          <CountBox
            id='events_last_2_weeks'
            label={'Events last 2 weeks'}
            count={eventsSummary.fortnight || 0}
            l={l}
            startDate={moment(currentTime).subtract(14, 'days')}
            endDate={currentTime}
          />
        </div>
        <div className="col-xs-3">
          <CountBox
            id='events_last_30_days'
            label={'Events last 30 days'}
            count={eventsSummary.month || 0}
            l={l}
            startDate={moment(currentTime).subtract(30, 'days')}
            endDate={currentTime}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  eventsSummary: portfoliosSelectors.getActivePortfolioEventsSummary(state),
  l: appSelectors.getL(state),
})

export default connect(mapStateToProps, appActions)(RawBox)



// WEBPACK FOOTER //
// ./src/views/notification-counts/index.js